import emergence from "emergence.js";
import { cookies } from "brownies";
import fitty from "fitty";
import Swiper from "swiper";

(function (window) {
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Variables
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var w = window,
    d = document,
    html = d.documentElement,
    body = d.body,
    header = $("#header"),
    header_h = header ? header.clientHeight : 0,
    footer = $("#footer"),
    main = $("#main"),
    subHeader = $("[data-fixed]", main),
    subHeader_container = subHeader
      ? subHeader.closest("[data-fixed-container]")
      : false,
    // nav_h,
    subHeader_h = subHeader ? subHeader.clientHeight : 0,
    windowH,
    windowW,
    scrollT,
    scrollUp = false,
    sauvScroll = 0,
    serveur_test = d.location.hostname == "localhost",
    adminBar = $("#wpadminbar"),
    has_adminBar = ffclass.has(body, "admin-bar"),
    adminBar_h = 0,
    is_requeting = false;

  cookies.expires = 0; //30 * 24 * 3600
  cookies.domain = url.cookie_domain;
  cookies.path = url.cookie_path;
  // cookies.secure = w.location.protocol === 'https:';
  // cookies.autojson = false;

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Dimensions
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function update_dimensions() {
    windowH = w.innerHeight;
    windowW = w.innerWidth;
    adminBar = !adminBar && has_adminBar ? $("#wpadminbar") : adminBar;
    adminBar_h = adminBar ? adminBar.innerHeight : 0;
    // subHeader_h = subHeader ? subHeader.innerHeight : 0;
    // nav_h = header ? header.innerHeight : 0;
    update_scroll();
  }
  function update_scroll() {
    if (w.pageYOffset < scrollT) {
      scrollUp = true;
    } else {
      scrollUp = false;
    }
    scrollT = w.pageYOffset;
  }
  update_dimensions();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Helper functions
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Easing functions (inspired by http://gizma.com/easing/)
  var easing = {
    linear: function (t) {
      return t;
    },
    easeInQuad: function (t) {
      return t * t;
    },
    easeOutQuad: function (t) {
      return t * (2 - t);
    },
    easeInOutQuad: function (t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function (t) {
      return t * t * t;
    },
    easeOutCubic: function (t) {
      return --t * t * t + 1;
    },
    easeInOutCubic: function (t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart: function (t) {
      return t * t * t * t;
    },
    easeOutQuart: function (t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart: function (t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint: function (t) {
      return t * t * t * t * t;
    },
    easeOutQuint: function (t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint: function (t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    },
  };

  //ScrollTo animate
  function scrollTo(Y, duration, easingFunction, callback) {
    var start = Date.now(),
      from = window.pageYOffset;

    if (from === Y) {
      if (callback) callback();
      return;
    }

    if (!easingFunction) easingFunction = easing.linear;

    function scroll(timestamp) {
      var currentTime = Date.now(),
        time = Math.min(1, (currentTime - start) / duration),
        easedT = easingFunction(time);

      yPos = easedT * (Y - from) + from;
      window.scrollTo(0, yPos);

      if (time < 1) requestAnimationFrame(scroll);
      else if (callback) callback();
    }

    requestAnimationFrame(scroll);
  }

  //Leadding zeros
  function pad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length - size);
  }

  //script async
  function async(script, callback) {
    var s = d.createElement("script"),
      t = d.getElementsByTagName("script")[0],
      r = false;
    // head = d.getElementsByTagName('head')[0];
    s.type = "text/javascript";
    // s.async = true;
    s.src = script;
    // if (typeof callback == 'function') { s.addEventListener('load', function (e) { callback.call(); }, false); }
    if (typeof callback == "function") {
      s.onload = s.onreadystatechange = function () {
        //console.log( this.readyState ); //uncomment this line to see which ready states are called.
        if (!r && (!this.readyState || this.readyState == "complete")) {
          r = true;
          callback();
        }
      };
    }
    // head.appendChild(s);
    t.parentNode.insertBefore(s, t);
  }

  //Url décode
  function urldecode(str) {
    return decodeURIComponent((str + "").replace(/\+/g, "%20"));
  }

  //Array chunk
  function array_chunk(array, chunk) {
    var i,
      j,
      temparray,
      array_return = [];
    chunk = chunk || 3;
    for (i = 0, j = array.length; i < j; i += chunk) {
      array_return.push(array.slice(i, i + chunk));
    }
    return array_return;
  }

  //Debounce
  function debounce(fn, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(this, arguments);
      }, wait || 1);
    };
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Supports
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // if(!support.objectFit) ffclass.add(html,'no-objectfit');
  // if(!support.objectPosition) ffclass.add(html,'no-objectposition');
  fallback_object_fit();

  function fallback_object_fit(cont) {
    if (support.objectFit) return;

    var fits = $$("img.cv-img:not(.srOnly)", cont || body);
    fits.forEach(function (fit, idx) {
      // var fitClass = ffclass.has(fit,'cv-contain') ? 'cv-bg-contain' : 'cv-bg';
      var srcFit = fit.hasAttribute("src") ? fit.getAttribute("src") : false;
      if (!srcFit)
        srcFit = fit.hasAttribute("data-src")
          ? fit.getAttribute("data-src")
          : false;
      if (!srcFit)
        srcFit = fit.hasAttribute("data-flickity-lazyload")
          ? fit.getAttribute("data-flickity-lazyload")
          : false;
      if (!srcFit) return;
      var replaceFit = d.createElement("div");
      replaceFit.className = fit.className;
      // replaceFit.className = fit.className + ' ' + fitClass;
      // ffclass.remove(replaceFit,'cv-img');
      // ffclass.remove(replaceFit,'cv-contain');
      replaceFit.style.backgroundImage = "url(" + srcFit + ")";
      fit.parentNode.appendChild(replaceFit);
      ffclass.add(fit, "srOnly");
      // ffclass.remove(fit,'cv-img');
    });
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu mobile
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var menuTrigger = $("#menuTrigger");
  var idMenuTimeOut = false;

  if (menuTrigger) {
    menuTrigger.addEventListener("click", menu_trigger, false);
  }

  function menu_trigger(event) {
    event.preventDefault();
    if (ffclass.has(html, "has-menuOpen")) {
      menu_close();
    } else {
      // scrollTo(0, 100, easing.linear, function() {
      //   menu_open();
      // });
      menu_open();
    }
  }

  function menu_close() {
    if (idMenuTimeOut) w.clearTimeout(idMenuTimeOut);
    if (!ffclass.has(html, "has-menuOpen")) return;
    ffclass.remove(html, "is-scrollBlocked");
    // w.scrollTo(0, 0);
    w.scrollTo(0, sauvScroll);
    w.setTimeout(function () {
      ffclass.remove(html, "has-menuOpen");
      ffclass.remove(menuTrigger, "is-active");
    }, 50);
  }

  function menu_open() {
    sauvScroll = scrollT;
    ffclass.add(html, "is-scrollBlocked");
    ffclass.add(menuTrigger, "is-active");
    ffclass.add(html, "has-menuOpen");
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Nav slide
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function nav_slide_update() {
    if (!ffclass.has(html, "has-menuOpen") && !scrollUp && scrollT > 0)
      ffclass.add(html, "is-nav-slided");
    else ffclass.remove(html, "is-nav-slided");
  }
  // nav_slide_update();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Header (menu ou filtres)
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function update_header() {
    adminBar = !adminBar && has_adminBar ? $("#wpadminbar") : adminBar;
    adminBar_h = !adminBar_h && adminBar ? adminBar.clientHeight : adminBar_h;
    if (subHeader) {
      if (
        subHeader.getBoundingClientRect().top <= adminBar_h &&
        (!subHeader_container ||
          subHeader_container.getBoundingClientRect().top +
            subHeader_container.clientHeight >=
            adminBar_h + subHeader_h)
      ) {
        if (!ffclass.has(subHeader, "is-fixed")) {
          ffclass.add(subHeader, "is-fixed");
        }
      } else {
        if (ffclass.has(subHeader, "is-fixed")) {
          ffclass.remove(subHeader, "is-fixed");
          // filters.removeAttribute('style');
        }
      }
    }
  }
  update_header();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Sliders
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  const insta_slider_init = () => {
    const swiper = new Swiper(".insta_swiper", {
      spaceBetween: 20,
      slidesPerView: "auto",
      breakpoints: {
        1024: {
          spaceBetween: 40,
        },
      },
    });
  };
  insta_slider_init();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Keys event
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  d.addEventListener("keydown", function (e) {
    if (e.keyCode == 27) {
      menu_close();
    }
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On resize
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function onResize() {
    update_dimensions();
  }
  w.addEventListener("resize", onResize, false);

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On scroll
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // function onScroll() {
  //   update_scroll();
  //   update_header();
  // }
  // w.addEventListener('scroll', onScroll, false);
  var ticking = false;
  function onScroll() {
    update_scroll();
    requestTick();
  }
  w.addEventListener("scroll", onScroll, false);

  function requestTick() {
    if (!ticking) {
      ticking = true;
      w.requestAnimationFrame(trigger_scroll);
    }
  }

  function trigger_scroll() {
    update_header();
    // nav_slide_update();
    ticking = false;
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Emergence
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

  function emergence_init() {
    emergence.init({
      reset: false,
      elemCushion: 0.05,
    });
  }

  emergence_init();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Fitty
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  if (typeof fitty !== undefined) {
    fitty(".post_title");
    setTimeout(() => {
      fitty(".post_title");
    }, 200);
  }
})(window);
